import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Officer } from 'src/app/Models/officer';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-officers',
  templateUrl: './officers.component.html',
  styleUrls: ['./officers.component.css'],
  providers: [DatePipe]
})
export class OfficersComponent implements OnInit {
  formTitle = "Manage Officers";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "id";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
   logtext:string = "";

  columns: string[][] =[ ["NAME","Name"],["POST","Post"],["DEPARTMENT","Department"],["MOBILE_NUMBER","Mobile Number"],["SEQUENCE_NO","Sequence No"]]

  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: Officer = new Officer();
  constructor(private api: ApiService,private message: NzNotificationService, private datePipe: DatePipe) { }
  ngOnInit() {
    this.search();

	this.logtext = 'OPENED - Officers form KEYWORD[O - Officers] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });
  }
  // Basic Methods
  sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.key;
    this.sortValue = sort.value;
    this.search(true);

  }
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
	
	this.logtext = 'Filter Applied - Officers form"+ sort +" "+this.sortKey +" KEYWORD [F - Officers] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
      });

    } catch (error) {
      sort = "";
    }
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)
      console.log("likeQuery" + likeQuery);
    }

	this.logtext = 'Filter Applied - Officers form "+ likeQuery +" KEYWORD [F - Officers] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
      });

    this.api.getAllOfficers(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];
    }, err => {
      console.log(err);
    });
  }
  //Drawer Methods
  get closeCallback() {
    return this.drawerClose.bind(this);
  }
  add(): void {
    this.drawerTitle = "Create New Officer";
    this.drawerData = new  Officer();
    this.drawerVisible = true;

	this.logtext = 'ADD - Officer form KEYWORD [A - Officer] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
      });

  }

  publish(): void {

    this.api.publish('officers')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/officers.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }


  preview(): void {

    this.api.preview('officers')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/preview/officers.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }

  edit(data:  Officer): void {
    if(data.IMAGE_URL!="")
    data.IMAGE_URL=this.api.retriveimgUrl + "OfficersImages/" + data.IMAGE_URL

    this.drawerTitle = "Update Officer";
    this.drawerData = Object.assign({}, data);
    this.drawerVisible = true;

	this.logtext = 'EDIT - Officer form KEYWORD [E - Officer] ';
	this.api.addLog('A',this.logtext,this.api.emailId)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
             console.log(successCode);
            }
            else {
		console.log(successCode);
            }
          });


  }
  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }
}